import { TextFieldProps } from '@mui/material';
import { extraireNombres } from 'cdx-common';
import { MuiTelInput } from 'mui-tel-input';
import React from 'react';

export type PhoneInputProps = Omit<TextFieldProps, 'variant' | 'value' | 'onChange'> & {
    value?: string | null,
    onChange: (value: string | null) => void;
};

export const PhoneInput = (props: PhoneInputProps) => {
    const { value, onChange, ...textFieldProps } = props;
    const phoneValue = React.useMemo(() => {
        const numericValue = extraireNombres(value ?? '');
        return numericValue ? `+${numericValue}` : '';
    }, [value]);

    return <MuiTelInput
        {...textFieldProps}
        defaultCountry='CA'
        onlyCountries={['CA']}
        value={phoneValue}
        onChange={newValue => {
            const phoneNumeric = extraireNombres(newValue);
            onChange(phoneNumeric === '' || phoneNumeric === '1' ? null : phoneNumeric);
        }} />;
};
